import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api.service';
import { GetUserPlansV2Params, GetUserPlansV2Response } from '../..';
import { CreateUserPlanParams } from 'src/app/core/proto/shopkeeper/user-plans/dtos/create-user-plan.params';

@Injectable({
  providedIn: 'root',
})
export class UserPlansService {
  constructor(private readonly apiService: ApiService) {}

  /**
   * Get user plans v2
   * permissions: {mode: "+r", res: "userPlan.*"}
   * v1 : this.apiService.get(`/v1/user-plans/consumers/consumer`, params)
   */
  getUserPlansV2(
    getUserPlansV2Params: GetUserPlansV2Params
  ): Observable<GetUserPlansV2Response> {
    const params: HttpParams =
      this.apiService.queryParams(getUserPlansV2Params);

    if (getUserPlansV2Params.lineId) {
      return this.apiService.get(
        `/v2-internal/user-plans/lines/${getUserPlansV2Params.lineId}`,
        params
      );
    } else if (getUserPlansV2Params.phoneNumber) {
      return this.apiService.get(
        `/v2/phone-numbers/${getUserPlansV2Params.phoneNumber}/user-plans`,
        params
      );
    } else if (getUserPlansV2Params.groupId) {
      return this.apiService.get(
        `/v2-internal/user-plans/groups/${getUserPlansV2Params.groupId}`,
        params
      );
    }

    return this.apiService.get(
      `/v2-internal/user-plans/endusers/enduser`,
      params
    );
  }

  createUserPlan(
    createUserPlanParams: CreateUserPlanParams
  ): Observable<GetUserPlansV2Response> {
    if (createUserPlanParams.lineId) {
      return this.apiService.post(
        `/v2/lines/${createUserPlanParams.lineId}/user-plans`,
        createUserPlanParams
      );
    } else if (createUserPlanParams.groupId) {
      return this.apiService.post(
        `/v2/groups/${createUserPlanParams.groupId}/user-plans`,
        createUserPlanParams
      );
    }

    return this.apiService.post(
      `/v2/phone-numbers/${createUserPlanParams.phoneNumber}/user-plans`,
      createUserPlanParams
    );
  }
}
